import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider } from './context/ToastContext';
import { OrgProvider } from './context/OrgContext';
import RequireAuth from './components/RequireAuth';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import DashboardPage from './pages/DashboardPage';
import ExamLibraryPage from './pages/ExamLibraryPage';
import ExamDetailsPage from './pages/ExamDetailsPage';
import QuestionBanksPage from './pages/QuestionBanksPage';
import QuestionBankDetailPage from './pages/QuestionBankDetailPage';
import QuestionBankUploadReviewPage from './pages/QuestionBankUploadReviewPage';
import ManageQuizPage from './pages/ManageQuizPage';
import ScreenerPage from './pages/ScreenerPage';
import ContentPage from './pages/ContentPage';
import StudentsPage from './pages/StudentsPage';
import BatchesPage from './pages/BatchesPage';
import SettingsPage from './pages/SettingsPage';
import WelcomePage from './pages/WelcomePage';
import QuizResultsPage from './pages/QuizResultsPage';
import StudentDetailPage from './pages/StudentDetailPage';

export default function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route
            element={
              <RequireAuth>
                <OrgProvider>
                  <Layout />
                </OrgProvider>
              </RequireAuth>
            }
          >
            <Route path="/" element={<DashboardPage />} />
            <Route path="/exam-library" element={<ExamLibraryPage />} />
            <Route path="/exam-library/:examId" element={<ExamDetailsPage />} />
            <Route path="/question-banks" element={<QuestionBanksPage />} />
            <Route path="/question-banks/:examId" element={<QuestionBankDetailPage />} />
            <Route path="/question-banks/uploads/:jobId" element={<QuestionBankUploadReviewPage />} />
            <Route path="/welcome" element={<WelcomePage />} />
            <Route path="/manage-quiz" element={<ManageQuizPage />} />
            <Route path="/manage-quiz/:quizId" element={<QuizResultsPage />} />
            <Route path="/screener" element={<ScreenerPage />} />
            <Route path="/content" element={<ContentPage />} />
            <Route path="/students" element={<StudentsPage />} />
            <Route path="/students/:userId" element={<StudentDetailPage />} />
            <Route path="/batches" element={<BatchesPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ToastProvider>
    </BrowserRouter>
  );
}
